import React from 'react'
import styled from 'styled-components'
import { useExpirationReportForm } from '../service/useExpirationReportForm'
import ExpirationReportForm from './ExpirationReportForm'
import { AppModal } from '../../../../../../generic/ui/Modal'
import { GridTable, TableToolbar } from '../../../../../../generic/grid-table'
import useExportToExcel from '../../../../../../generic/hooks/useExportToExcel'
import columnsToExcel from '../../../../../../generic/universal-table/utils/columnsToExcel'
import { EXPIRATION_REPORT_COLUMNS } from '../constance/config'
import { ExpirationReportRow } from '../types/row'

const EXPIRATION_REPORT_EXCEL_COLUMNS = columnsToExcel(EXPIRATION_REPORT_COLUMNS)

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  width: 100%;
  height: 100%;
  padding: 0.5em;
  overflow: hidden;
`

const ExpirationReport = () => {
    const {
        handleSubmit,
        products,
        productId,
        setProductId,
        growerList,
        growerId,
        setGrowerId,
        isOpen,
        warehouseList,
        warehouseId,
        expirationReportList,
        searchInput,
        setSearchInput,
        handleControlModal,
        formValues,
    } = useExpirationReportForm()

    const { handleExport } = useExportToExcel<ExpirationReportRow>({
      columns: EXPIRATION_REPORT_EXCEL_COLUMNS,
      fileName: 'expiration-report',
      rtl: true,
    })

  return (
    <TableSection>
        {isOpen && (
        <AppModal
            title='שאילתת איתורים'
            Children={ExpirationReportForm}
            controlFunc={expirationReportList ? handleControlModal : undefined}
            childrenProps={{
                handleSubmit,
                products,
                productId,
                setProductId,
                growerList,
                growerId,
                setGrowerId,
                warehouseList,
                warehouseId,
                formValues
            }}
            size='sm'
            disableOutsideClick={!expirationReportList}
            disableHide={!expirationReportList}
         />
         )}
         {expirationReportList && (
            <GridTable<ExpirationReportRow>
                title="שאילתת איתורים"
                count={expirationReportList.length}
                columns={EXPIRATION_REPORT_COLUMNS}
                rows={expirationReportList}
                getRowId={(row) => row.rowId}
                toolbarActions={
                    <TableToolbar
                        searchValue={searchInput}
                        onSearchChange={setSearchInput}
                        searchPlaceholder="חיפוש פריט…"
                        onExport={() => handleExport(expirationReportList)}
                        onFilter={handleControlModal}
                    />
                }
            />
         )}
    </TableSection>
  )
}

export default ExpirationReport
